/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createFieldHook } from '../../core/factories/createFieldHook.js';
import { createListHook } from '../../core/factories/createListHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetUserMarketsRow } from '../openapi-types.gen.js';
import type { PagedData } from '../../types/PagedData.js';
import { type useGetUserMarketsArgs, useGetUserMarketsSpec, useGetUserMarketsRealtime, useGetUserMarketsPagination } from '../specs/users.spec.gen.js';
import type { PaginationContract } from '../../core/factories/createListHook.js';

export type { GetUserMarketsRow } from '../openapi-types.gen.js';
export type { useGetUserMarketsArgs } from '../specs/users.spec.gen.js';

// Codegen-typed pagination contract is narrower than the runtime
// PaginationContract signature (which takes unknown args). The cast erases
// the call-site narrowness — the runtime fetcher itself remains typed.
const _useGetUserMarketsPaginationContract = useGetUserMarketsPagination as unknown as PaginationContract;

/**
 * Manual pagination: returns `fetchNextPage` / `hasNextPage` /
 * `isFetchingNextPage` so the caller wires a "Load more" button or
 * pagination control. Same cache entry as `useGetUserMarketsInfinite` — both
 * read/write the same `PagedData<GetUserMarketsRow>` blob.
 *
 * @remarks Available query params (forwarded automatically; pass
 * via the hook's args): userId, limit, fields.
 */
export const useGetUserMarkets = createListHook({
  spec: useGetUserMarketsSpec,
  realtime: useGetUserMarketsRealtime,
  entityKey: 'user',
  pagination: _useGetUserMarketsPaginationContract,
});


/**
 * Auto-infinite: same cache as `useGetUserMarkets`, but the last-row viewport
 * sentinel auto-fires `fetchNextPage` so the consumer never has to wire
 * it. Use for scroll-driven feeds; use `useGetUserMarkets` for "Load more"
 * buttons / non-scroll UX.
 */
export const useGetUserMarketsInfinite = createListHook({
  spec: useGetUserMarketsSpec,
  realtime: useGetUserMarketsRealtime,
  entityKey: 'user',
  pagination: _useGetUserMarketsPaginationContract,
  autoLoadMore: true,
});


/**
 * Per-field subscription hook for the `useGetUserMarkets` cache entry. Call inside
 * an `<Items>` render tree (typically from a leaf component). Returns the
 * named field's value for the given row id; only the call site re-renders
 * when that field changes. Uses TanStack's canonical "per-component select"
 * pattern internally.
 *
 *     function Volume({ pubkey }) {
 *       const value = useGetUserMarketsField(pubkey, 'volume24h');
 *       return <span>{value}</span>;
 *     }
 */
export const useGetUserMarketsField = createFieldHook<GetUserMarketsRow>('useGetUserMarketsField');

/**
 * Hover/intent prefetch companion for `useGetUserMarkets` (also covers
 * `useGetUserMarketsInfinite` — same cache entry). Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * for page 1 and writes the response into the cache. The component owning
 * the callback does NOT subscribe — no re-renders on data, no NATS
 * subscription. Idempotent: TanStack `prefetchQuery` is a no-op when a
 * fresh cache entry already exists.
 *
 *     function NavLink() {
 *       const prefetch = usePrefetchGetUserMarkets();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({})}
 *           onFocus={() => prefetch({})}
 *         >Markets</a>
 *       );
 *     }
 */
export const usePrefetchGetUserMarkets = createPrefetchHook(useGetUserMarketsSpec);
